<template>
    <div>
        <div class="fixed_bg"></div>
        <div class="form_panel">
            <div class="form_header">
                <span class="title">{{editstatus?'修改':'添加'}}用户</span>
                <span class="close_icon" v-on:click="close()" title="关闭">X</span>
            </div>
            <div class="form_content">
                <div class="form_group">
                    <label for="">模式</label>
                    <select class="disabled" v-if="editstatus" name="" id="" v-model="userData.external" disabled>
                        <option value="0">内部</option>
                        <option value="1">外部</option>
                    </select>
                    <select v-if="!editstatus" name="" id="" v-model="userData.external">
                        <option value="0">内部</option>
                        <option value="1">外部</option>
                    </select>
                </div>
                <div class="form_group">
                    <label for="">用户名</label>
                    <input class="disabled" v-if="editstatus" type="text" v-model="userData.username" disabled>
                    <input v-if="!editstatus" type="text" v-model="userData.username">
                </div>
                <div class="form_group">
                    <label for="">邮箱地址</label>
                    <input type="email" v-model="userData.email">
                </div>
                <div class="form_group">
                    <label for="">部门</label>
                    <select name="" id="" v-model="userData.accountId">
                        <option v-bind:value="item.id" v-for="item in accountList">{{item.accountName}}</option>
                    </select>
                </div>
                <div class="form_group">
                    <label for="">角色</label>
                    <select v-if="userData.external == 1" name="" id="" v-model="userData.roleId" @keyup.enter="addOneUser()">
                        <option v-bind:value="item.id" v-for="item in roleList.external">{{item.description}}</option>
                    </select>
                    <select v-if="userData.external == 0" name="" id="" v-model="userData.roleId" @keyup.enter="addOneUser()">
                        <option v-bind:value="item.id" v-for="item in roleList.internal">{{item.description}}</option>
                    </select>
                </div>
                <div class="form_group" v-if="userData.external == 1">
                    <label for="">密码</label>
                    <input v-if="!editstatus" type="password" v-model="userpassword">
                    <input v-if="editstatus" placeholder="默认不修改密码" type="password" v-model="userpassword" value="">
                </div>
                <div class="form_group" v-if="userData.external == 1" @keyup.enter="addOneUser()">
                    <label for="">确认</label>
                    <input v-if="!editstatus" type="password" v-model="passwordConfirm">
                    <input v-if="editstatus" placeholder="默认不修改密码" type="password" v-model="passwordConfirm">
                </div>
            </div>
            <div class="form_footer">
                <button class="btn btn_bg" v-on:click="addOneUser()">是</button>
                <button class="btn btn_bg_cancel btn_right" v-on:click="close()">取消</button>
            </div>
        </div>
        <!--<tip v-if="ifShow" v-bind:status="sendStatus" v-bind:message="sendMessage"></tip>-->
    </div>
</template>

<script>
import { getAccountList, getRoleList,addUser } from "../../util/api.js";
import Tip from "@/components/common/tip";
import { mapState, mapActions } from "vuex";

export default {
  name: "AddUser",
  props:['userData','editstatus'],
  components: { Tip },
  /*computed: {
    ifShow: state => state.ifShowMessage
  },*/
  data() {
    return {
        accountList:[],
        roleList:[],
        userpassword:'',
        passwordConfirm:'',
        sendStatus: false,
        sendMessage: ""
    };
  },
  mounted: function() {
    let that = this;
    that.$store.commit("getIfShowMessage", false);
    getAccountList()
      .then(function(res) {
        that.accountList = res.data;
        console.log(that.accountList);
      })
      .catch(function(error) {
        
      });

    getRoleList()
      .then(function(res) {
        that.roleList = res.data;
      })
      .catch(function(error) {
        console.log(error);
      });
  },
  methods:{
      addOneUser:function(){
        let sendData = {
          username: this.userData.username,
          email:this.userData.email,
          external: this.userData.external,
          accountId: this.userData.accountId,
          roleId: this.userData.roleId
        };
        if(this.userData.id){
          sendData.id = this.userData.id;
        }
        if(this.userData.external == 1){
          if(this.userpassword == this.passwordConfirm){
            //要密码
            sendData.coffee = this.userpassword;
            this.$emit("listentoChild", {success:true,data:sendData});
            this.$store.commit("closeAddUser");
          }else if(this.userpassword != this.passwordConfirm && !this.passwordConfirm == ''){
            this.$emit("listentoChild", {success:false});
          }else{
            this.$emit("listentoChild", {success:true,data:sendData});
            this.$store.commit("closeAddUser");
          }
        }else{
          this.$emit("listentoChild", {success:true,data:sendData});
            this.$store.commit("closeAddUser");
        }
      },
      close: function() {
       this.$store.commit("closeAddUser");
    }
  }
};
</script>

<style scoped>
.fixed_bg {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  background-color: #000;
  opacity: 0.5;
}
.form_panel {
  width: 4.79rem;
  padding-bottom:0.24rem;
  background-color: #fff;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
}
.form_header {
  line-height: 0.54rem;
  padding: 0 0.24rem;
  border-bottom: 1px solid #d8d8d8;
  text-align: left;
}
.form_header .title{
  font-size: 14px;
  font-weight: bold;
}
.close_icon {
  float: right;
  cursor: pointer;
  width: 20px;
  text-align: center;
}
.form_content {
  padding-left: 0.72rem;
  padding-top: 0.2rem;
}
.form_group label {
  width: 0.61rem;
  display: inline-block;
  font-size: 0.15rem;
  color: #000;
}
.form_group {
  text-align: left;
}
.form_group input,
.form_group select {
  width: 2.48rem;
  height: 0.46rem;
  margin-left: 0.14rem;
  margin-bottom: 0.19rem;
  border: 1px solid #d8d8d8;
  padding-left: 5px;
}
.form_group select {
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  background: url(../../assets/select_down.png) no-repeat 2.2rem;
  padding-right: 20px;
  background-color: #fff;
  z-index: 111;
}
.btn {
  width: 1.19rem;
  height: 0.4rem;
  border: 0;
  border-radius: 2px;
}
.btn_bg {
  background-color: #fa5400;
  color: #fff;
}
.btn_bg_cancel {
  background-color: #cccccc;
  color: #fff;
}
.btn_right {
  margin-left: 0.14rem;
}
.disabled,.form_group  .disabled{
  background-color: #fbfbfb;
  color: #c9c9c9;;
}
</style>




// WEBPACK FOOTER //
// src/components/common/addUser.vue